import { render, staticRenderFns } from "./ModalEndereco.vue?vue&type=template&id=d9b59a16"
import script from "./ModalEndereco.vue?vue&type=script&lang=ts"
export * from "./ModalEndereco.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports